const CrudTypesEnum=
{
    Create:'Create',
    Read:'Read',
    Update:'Update',
    Delete:'Delete',
};

export default CrudTypesEnum;